import React from 'react'

const Preview = ({ config, children }) => {
  const angle = config.angle * -180 / Math.PI + 90
  const brightness = (config.darken - 5.25) * -0.2

  return (
    <div className="position-absolute w-100 h-100" style={{
      backgroundImage: `linear-gradient(${angle}deg, ${config.cscale.join()})`,
      filter: `brightness(${brightness}) contrast(1.1) saturate(1.1)`,
    }}>{children}</div>
  )
}

export default Preview
